import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import PropTypes from 'prop-types'

const Seo = ({ title, description, keywords, meta }) => {

  const { site } = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          description
          title
        }
      }
    }
  `)

  const metaDesc = description || site.siteMetadata.description
  const defaultTitle = site.siteMetadata?.title
  const metaTitle = title || site.siteMetadata.title

  let metaProps = [
    {
      name: `description`,
      content: metaDesc,
    },
    {
      name: `keywords`,
      content: keywords,
    },
    {
      property: `og:title`,
      content: title,
    },
    {
      property: `og:description`,
      content: metaDesc,
    },
    {
      property: `og:type`,
      content: `website`,
    },
    {
      name: `twitter:card`,
      content: `summary`,
    },
    {
      name: `twitter:creator`,
      content: site.siteMetadata?.social?.twitter || ``,
    },
    {
      name: `twitter:title`,
      content: title,
    },
    {
      name: `twitter:description`,
      content: metaDesc,
    },
  ]


  if (meta) {
    metaProps = metaProps.concat(meta)
  }

  return (
    <>
      <title>
        {defaultTitle ? `${metaTitle} | ${defaultTitle}` : null}
      </title>
      {metaProps.map(({ name, property, content }) => (
        <meta
          key={`${name || property}`}
          name={name}
          property={property}
          content={content}
        />
      ))}
    </>
  )
}

Seo.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  keywords: PropTypes.string,
  meta: PropTypes.oneOfType([
    PropTypes.exact({
      name: PropTypes.string,
      content: PropTypes.string,
      property: PropTypes.string,
    }),
    PropTypes.arrayOf(
      PropTypes.exact({
        name: PropTypes.string,
        content: PropTypes.string,
        property: PropTypes.string,
      })
    )
  ])
}

export default Seo
